import { render } from "./AuthCallback.vue?vue&type=template&id=70450631&ts=true"
import script from "./AuthCallback.vue?vue&type=script&lang=ts"
export * from "./AuthCallback.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__